export default {
  cartonNumber: '箱号',
  scanDate: '扫描时间',
  tunnelID: '通道机编号',
  filter: 'Filter',
  rfid: 'EPC',
  productCode: '产品编号',
  size: 'Size',
  upc: 'UPC',
  productName: '产品名称',
  purchaseOrder: '采购订单号',
  salesOrder: '销售订单号',
  IB: 'IB',
  IBTitle: 'IB ',
  IBCartonNumber: '箱号',
  IBOriginalCartonNumber: '原箱号',
  IBASN: 'ASN',
  IBTunnelID: '通道机编号',
  IBLPNSizeType: '物流包装单元尺寸类型',
  IBFactoryCode: '工厂代码',
  IBCarrier: '承运商',
  IBItemAttribute: '物品属性',
  IBGRDate: 'GR 时间',
  IBScanDate: '扫描时间',
  OB: 'OB',
  OBTitle: 'OB ',
  OBCartonNumber: '箱号',
  OBDeliveryNoteNo: '送货单号',
  OBMajor: 'Major',
  OBTunnelID: '通道机编号',
  OBTaskType: 'Task Type',
  OBSOType: 'SO 类型',
  OBCarrier: '承运商',
  OBRetag: '补标',
  OBShipFrom: '发货地',
  OBShipTo: '收货地',
  OBStore: '门店',
  OBItemAttribute: '物品属性',
  OBTrailerNumber: '承运车牌号',
  OBCartonNetWeight: 'Carton Net Weight',
  OBCartonGrossWeight: 'Carton Gross Weight',
  OBGIDate: 'GI 时间',
  OBScanDate: '扫描时间',
  multipleASNNotice: '多ASN标记',
  multipleDNNotice: '多DN标记'
}
